<template>
    <div>
        <b-modal id="modalDescarte" data-backdrop="static" data-keyboard="false" centered
            :title="this.$t('Conserto de Pneus')">


            <div class="container">
                <span>{{ $t('Selecione um fornecedor') }}:</span>
                <v-select :filterable="false" :options="fornecedores" :placeholder="$t('Digite para pesquisar')" v-model="form.fornecedor" @search="onSearch">
                </v-select>
            </div>

            <div class="container mt-4">
                <span>{{ $t('Selecione um motivo') }}:</span>
                <v-select :options="motivos" v-model="form.motivos">
                </v-select>
            </div>

            <div class="container mt-4">
                <span>{{ $t('Serviço') }}:</span>
                <v-select :options="servicos" v-model="form.servico">
                </v-select>
            </div>
 
            <div class="container mt-4">
                <span>{{ $t('Observação') }}:</span>

                <input class="form-control" type="text" v-model="form.observacao">
            </div>

            <div class="container mt-4">
                <span>{{ $t('Data') }}:</span>

                <input class="form-control" type="date" id="dataDescarte" v-model="dataDescarte">

            </div>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <div class="row center" style="justify-content: center;">
                        <b-button class="mr-2" variant="danger" size="lg" @click="cancel(), modalShow = false">
                            {{ $t('Fechar') }}
                        </b-button>
                        <b-button class="mr-2" variant="success" size="lg" @click="realizarDescarte()">
                            <i class="fa fa-cog" aria-hidden="true" style="margin-right: 8px"></i>{{ $t('Serviço') }}
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>

export default {
    name: "ModalExterna",

    data() {
        return {
            dataDescarte: this.getCurrentDate(), // Define a data atual como valor padrão
            form: {}
        };
    },

    props: {
        pneu: {}
    },
 
    computed: {
        fornecedores() {
            const fornecedores = this.$store.getters['borracharia/getFornecedores']

            if (!fornecedores) {
                this.$store.dispatch('borracharia/getFromDescarte')

                return []
            }

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        },
        motivos() {
            const motivos = this.$store.getters['borracharia/getMotivos']

            if (!motivos) {
                this.$store.dispatch('borracharia/getFromDescarte')

                return []
            }

            return motivos.map(motivo => {
                return {
                    ...motivo,
                    label: motivo.ds_motivo
                }
            })     
        },
        servicos() {
            const servicos = this.$store.getters['borracharia/getServicos']

            if (!servicos) {
                this.$store.dispatch('borracharia/getFromDescarte')

                return []
            }

            return servicos.map(servico => {
                return {
                    ...servico,
                    label: servico.ds_servico
                }
            })
        },
    },
    methods: {
        onSearch(search) {
            console.log(search)
            // Aqui chamamos o Vuex action para buscar os fornecedores com base no input
            // this.searchQuery = search;
            this.fetchFornecedores(search);
        },
        
        async fetchFornecedores(searchQuery) {
            this.loading = true;
            try {
                await this.$store.dispatch('borracharia/getFornecedoresDescartes', searchQuery);
            } catch (error) {
                console.error("Erro ao buscar fornecedores", error);
            } finally {
                this.loading = false;
            }
        },
        realizarDescarte() {

            // this.$refs.hide('modalDescarte')
            this.$bvModal.hide('modalDescarte')

            const data = {
                fornecedor: this.form.fornecedor.nr_sequencial,
                motivos: this.form.motivos.cd_motivo,
                observacao: this.form.observacao,
                data: this.dataDescarte,
                servico: this.form.servico,
                pneu: this.pneu
            }

            this.$store.dispatch('borracharia/postDescarte', { data: data }).then(() => {
                this.$swal.fire({
                    title: 'Sucesso!',
                    text: 'Descarte realizado com sucesso!',
                    icon: 'success'
                })

                this.form = {}
                this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
                this.$bvModal.hide('modalDescarte')
            })
            .catch((error) => {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Erro ao descartar peneu, tente novamente!',
                    icon: 'error'
                })
            })
        },

        getCurrentDate() {
            const now = new Date();
            // Formata a data para o formato 'yyyy-MM-dd' aceito pelo input tipo date
            return now.toISOString().slice(0, 10);
        }
    }

}
</script>

<style src="./style.css" />
